import React, {useState, useEffect} from 'react';
import './style.scss';

import i18n from 'live/services/i18n';
import styled from 'styled-components';
import FilterDropdown from 'live/components/forms/ui/filter-dropdown';
import { ItemSort } from '../../types';

type Props = {
    options: ItemSort[][],
    onClick(option:ItemSort): void
}

const DropdownSort = ({options, onClick}: Props): JSX.Element => {

    const [optionSelected, setOptionSelected] = useState<ItemSort>();

    const onClickLi = (option: ItemSort) => {        
        onClick(option)
        setOptionSelected(option)
    }

    useEffect(() => {
        if(options){
            for(let option of options){
                const aux = option.find(ele => ele.active === true)

                if(aux){
                    setOptionSelected(aux)
                    break;
                }
            }
        }
    }, [options])

    return <FilterDropdown hideTitle={true} disableTooltip={true}
                containerClassName="smart-mobility-dropdown-sort"        
                btnLabel={
                    <BtnLabel>
                        <i className={`far ${optionSelected?.order == 1 ? 'fa-long-arrow-down' : 'fa-long-arrow-up' }`} style={{marginRight: 8}}/>
                        <span>{optionSelected?.title}</span>
                    </BtnLabel>
                }>
                
                <Wrapper>
                    {
                      options?.map((options, index) => {
                        return <Options key={index}>
                            {
                                options?.map((option: ItemSort, index) => {
                                    const {title, description} = option;
                                    return <LiOption key={index} active={option === optionSelected} onClick={() => onClickLi(option)}>
                                        <span>
                                            <i className='fas fa-check' style={{visibility: `${option === optionSelected ? 'visible' : 'hidden'}`}}></i>
                                            {title}:
                                        </span>
                                        <span>{description}</span>
                                    </LiOption>
                                })
                            }
                        </Options>
                      })  
                    }
                </Wrapper>
            </FilterDropdown>
}

export default DropdownSort;

const Wrapper = styled.div`
    
`

const BtnLabel = styled.div`
    padding: 0 16px !important;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover{ 
        background-color: ${({theme}) => theme['blue-200']};
    }
`

const Options = styled.ul`
    margin: 0;
    padding: 0;    
    border-bottom: 1px solid ${({theme}) => theme['gray-400']};

    &:last-of-type{
        border: none;
    }
`

const LiOption = styled.li`
    padding: 5px 16px;    
    display: flex;
    align-items: center;
    justify-content: start;
    font-weight: ${({active}) => active ? 600 : 400};
    font-size: 13px;
    color: ${({theme, active}) => active ? theme['blue-500'] : theme['gray-700']};

    span:first-of-type{
        margin-right: 8px;

        i{
            margin-right: 8px;
        }
    }

    &:hover{
        cursor: pointer;
        background-color: ${({theme}) => theme['blue-200']};
    }
`